<template>
  <DefaultLayout body-class="pacsort-login">
    <div class="login-page">
      <a href="#logout" class="skip-link">Skip to sign-out confirmation</a>
      <main class="login-surface">
        <header class="brand-header">
          <a class="brand-mark" href="https://21grams.se/" aria-label="21grams home">
            <img src="@/assets/images/login-brand/mark.svg" width="110" height="110" alt="" />
          </a>
          <a class="brand-wordmark" href="https://pacsortonline.com/" aria-label="PacSort Online home">
            <img src="@/assets/images/login-brand/wordmark.svg" width="110" height="28" alt="21grams" />
          </a>
        </header>
        <section id="logout" class="login-content logout-content" aria-labelledby="logout-heading">
          <p class="product-name">PacSort Analytics</p>
          <div class="logout-confirmation" aria-hidden="true">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="m5 12 4 4L19 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </div>
          <h1 id="logout-heading">You’re logged out</h1>
          <p class="logout-description">You have been securely signed out of PacSort Analytics.</p>
          <router-link to="/login" class="login-button logout-login">Log in again <span aria-hidden="true">→</span></router-link>
          <a class="back-link" href="https://pacsortonline.com/">Go to PacSort Online <span aria-hidden="true">→</span></a>
        </section>
      </main>
      <footer class="login-footer">
        <div class="footer-main">
          <div class="footer-identity">
            <a href="https://21grams.se/" class="footer-logo" aria-label="21grams home">
              <img src="@/assets/images/login-brand/footer-mark.svg" width="32" height="48" alt="" />
              <img src="@/assets/images/login-brand/footer-wordmark.svg" width="110" height="48" alt="21grams" />
            </a>
            <p>PacSort Analytics</p>
          </div>
          <div class="support">
            <a class="contact-link" href="https://21grams.se/kontakt/">Contact us <span aria-hidden="true">→</span></a>
            <a href="mailto:support@21grams.com">support@21grams.com</a>
            <a href="tel:004686003721">+46 (8) 600 37 21 · option 2</a>
          </div>
        </div>
        <div class="footer-bottom">
          <span>© {{ new Date().getFullYear() }} 21grams</span>
          <nav aria-label="Footer">
            <a href="https://pacsortonline.com/info/privacy-policy/">Privacy Policy</a>
            <a href="https://pacsortonline.com/info/additional-charges/">Terms of Use</a>
            <a href="https://pacsortonline.com/faq">FAQ</a>
          </nav>
        </div>
      </footer>
    </div>
  </DefaultLayout>
</template>
<script setup lang="ts">
import { onMounted } from 'vue'
import DefaultLayout from '@/views/components/layouts/default-layout.vue'
import { useAuthStore } from '@/requests/Auth'
const auth = useAuthStore()
onMounted(() => auth.logout())
</script>
<style scoped src="./auth-brand.css"></style>
<style scoped>
.logout-content { padding-bottom: 24px; }
.logout-confirmation { display: flex; align-items: center; justify-content: center; width: 56px; height: 56px; margin: 28px 0 22px; border-radius: 50%; background: #184f46; color: #b8d9c5; }
.logout-content h1 { color: #fff; font-size: 32px; line-height: 1.2; }
.logout-description { color: #bfd0ce; margin: 14px 0 30px; font-size: 16px; line-height: 1.6; }
.logout-login { display: flex; align-items: center; justify-content: center; padding: 0 20px; text-decoration: none; }
.logout-login:hover { text-decoration: none; }
@media (max-width: 600px) { .logout-content h1 { font-size: 28px; } }
</style>
